/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import type { WhisperTypes } from '../../views/Whisper/WhisperTypes';
import { hideWhisperAction, showWhisperAction } from './whisper.actions';
import { HIDE_WHISPER, SHOW_WHISPER } from './whisper.types';

type TWhisperStateType = {
    isWhisperActive: boolean;
    message?: string;
    iconType?: WhisperTypes;
};

const initialState: TWhisperStateType = {
    isWhisperActive: false,
};

const whisperReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<TWhisperStateType>>{},
) => {
    switch (type) {
        case SHOW_WHISPER:
            return {
                ...state,
                isWhisperActive: true,
                message: payload.message,
                iconType: payload.iconType,
            };
        case HIDE_WHISPER:
            return {
                ...state,
                isWhisperActive: false,
                message: undefined,
                iconType: undefined,
            };
        default:
            return state;
    }
};

export const showWhisper =
    (showWhisperParams?: Omit<TWhisperStateType, 'isWhisperActive'>) =>
    (dispatch: Function, getState: Function) => {
        const { isWhisperActive } = getState().whisper;
        if (!isWhisperActive) {
            dispatch(showWhisperAction(showWhisperParams?.message, showWhisperParams?.iconType));
        }
    };

export const hideWhisper = () => (dispatch: Function, getState: Function) => {
    const { isWhisperActive } = getState().whisper;
    if (isWhisperActive) dispatch(hideWhisperAction());
};

export default whisperReducer;
